import React from 'react';
import ShortageConsentModal, { normaliseShortages } from '../shared/ShortageConsentModal';

/** Missing Ingredients for a banquet — the shared consent popup with banquet wording. */
export { normaliseShortages };

const BanquetShortageModal = (props) => (
  <ShortageConsentModal
    {...props}
    description="This banquet needs more stock than is on hand. Recording it will take these ingredients below zero, exactly as a TSR would."
  />
);

export default BanquetShortageModal;
